import { useUntilChangesetKeyValue } from '../../context/useUntilChangesetKeyValue'
import { configurationItem } from '../../system/paths'
import { useNavigationParams } from '../../system/useNavigationParams'
import { getParameterDefinitionInOut } from '../../uiModels/parameterOperations/helpers'
import type { IndexedParameterDefinitionCreateOperationWithMetaData } from '../../uiModels/parameterOperations/types'
import { useOperationsContext } from '../../workspace/operationsContext'
import { OperationVersionTooltipEntry } from '../versionedTimeline/OperationVersionTooltipEntry'
import type { TooltipData } from '../versionedTimeline/VersionedArrowsGroup'
import { useIsParameterVersionActive } from './useIsParameterVersionActive'

export const ParameterDefinitionInOutTooltipContent = ({
  versions: versionsWithDraftData,
}: TooltipData<IndexedParameterDefinitionCreateOperationWithMetaData>) => {
  const { workspaceKey, branchKey } = useOperationsContext()
  const { server } = useNavigationParams()
  const untilChangesetKeyValue = useUntilChangesetKeyValue()
  const isVersionActive = useIsParameterVersionActive()

  return (
    <div className="flex flex-col gap-y-2">
      {versionsWithDraftData.map((version) => {
        const identifier = version.internalOperation.entity?.name ?? ''
        const definitionInOut = getParameterDefinitionInOut(version)
        const isActive = isVersionActive(version)

        const isLockedToChangeset =
          !!untilChangesetKeyValue &&
          version.changesetHistory?.changesetKey === untilChangesetKeyValue
        const to = !version.isDraft
          ? configurationItem({
              block: version.block,
              layer: version.layer,
              itemId: identifier,
              type: 'parameterDefinition',
              workspaceName: workspaceKey?.name,
              branch: branchKey?.name,
              server: workspaceKey?.branchKey.server ?? server,
              untilChangesetKey: version.changesetHistory?.changesetKey,
            })
          : undefined
        const fromDate = definitionInOut.fromDate
        const changesetHistory = version.changesetHistory

        return (
          <OperationVersionTooltipEntry
            key={version.internalOperation.operationKey}
            identifier={identifier}
            isActive={isActive}
            isDraft={version.isDraft}
            isInherited={false}
            isHideVersion={false}
            isLockedToChangeset={isLockedToChangeset}
            to={to}
            fromDate={fromDate}
            changesetHistory={changesetHistory}
            layer={version.layer}
            block={version.block}
          />
        )
      })}
    </div>
  )
}
